import { useEffect, useRef, useState } from "react";
import DateUtils from "../../../../utils/DateUtils";

export default function DateInput({ onChange, defaultValue }: {
    onChange?: (date: Date | null) => void;
    defaultValue?: Date;
}) {
    const [day, setDay] = useState(defaultValue ? defaultValue.getDate().toString().padStart(2, "0") : "");
    const [month, setMonth] = useState(defaultValue ? (defaultValue.getMonth() + 1).toString().padStart(2, "0") : "");
    const [year, setYear] = useState(defaultValue ? defaultValue.getFullYear().toString() : "");

    const calendarRef = useRef<HTMLInputElement>(null);

    useEffect(() => {

        setDay(defaultValue ? defaultValue.getDate().toString().padStart(2, "0") : "");
        setMonth(defaultValue ? (defaultValue.getMonth() + 1).toString().padStart(2, "0") : "");
        setYear(defaultValue ? defaultValue.getFullYear().toString() : "");

    }, [defaultValue])



    const handleChange = (d: string, m: string, y: string) => {
        if (d && m && y) {

            if (Number(y) <= 0 || Number(m) <= 0 || Number(d) <= 0 || Number(m) > 12 || Number(d) > 31 || Number(y) < 1900 || Number(y) > new Date().getFullYear()) {
                onChange?.(null);
                return;
            }

            const parsed = new Date(Number(y), Number(m) - 1, Number(d));
            if (!isNaN(parsed.getTime())) {
                onChange?.(parsed);
            } else {
                onChange?.(null);
            }
        } else {
            onChange?.(null);
        }
    };

    return (
        <div className="INputDateComponent" style={{ display: 'flex', flexDirection: 'row', gap: '5px', width: '150px', alignItems: 'start' }}>
            <input
                type="number"
                placeholder="DD"
                min={1}
                max={31}
                value={day}
                onClick={()=> setDay("")}
                onChange={(e) => {

                    handleChange(e.target.value, month, year);
                    
                    if(e.target.value.length > 2) {
                            setDay("");
                            return;
                        }

                    if (e.target.value.length == 2) {

                        let dayNum = Number(e.target.value);
                        if (dayNum < 1) {
                            setDay("");
                            return;
                        }
                        if (dayNum > 31) {
                            setDay("");
                            return;
                        }
                    }

                    setDay(e.target.value);
                }}
                style={{ width: '40px', textAlign: 'center' }}
            />
            <input
                type="number"
                placeholder="MM"
                min={1}
                max={12}
                value={month}
                onClick={()=> setMonth("")}
                onChange={(e) => {

                    handleChange(day, e.target.value, year);

                    if(e.target.value.length > 2) {
                            setMonth("");
                            return;
                        }

                    if (e.target.value.length == 2) {

                        let monthNum = Number(e.target.value);
                        if (monthNum < 1) {
                            setMonth("");
                            return;
                        }
                        if (monthNum > 12) {
                            setMonth("");
                            return;
                        }
                    }
                    setMonth(e.target.value);
                }}
                style={{ width: '40px', textAlign: 'center' }}

            />
            <input
                type="number"
                placeholder="AAAA"
                min={1900}
                max={2100}
                value={year}
                onClick={()=> setYear("")}
                onChange={(e) => {

                    handleChange(day, month, e.target.value);

                       if(e.target.value.length > 4) {
                            setYear("");
                            return;
                        }

                    if (e.target.value.length == 4) {
                        let yearNum = Number(e.target.value);
                        if (yearNum < 1900) {
                            setYear("");
                            return;
                        };
                        if (yearNum > 2100) {
                            setYear("");
                            return;
                        };
                    }
                    setYear(e.target.value);
                }}

                style={{ width: '65px', textAlign: 'center' }}
            />
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="pi pi-calendar" onClick={
                   () => {                     
                    calendarRef.current?.click();}
                }></i>
                <input ref={calendarRef} type="date" style={{opacity: 0, width: '5px'}} onChange={(e) => {

                    let date = DateUtils.CastStringToDate(e.target.value);                    
                  
                    if (date) {
                        setDay(date.getDate().toString().padStart(2, "0"));
                        setMonth((date.getMonth() + 1).toString().padStart(2, "0"));
                        setYear(date.getFullYear().toString());
                        onChange?.(date);
                    } else {
                        setDay("");
                        setMonth("");
                        setYear("");
                        onChange?.(null);
                    }

                }}/>
            </div>
            
        </div>
    );
}
